import { useState, useContext, useEffect } from "react";
// Material UI Components
import { Box, Stack, Button, Fade } from "@mui/material";
// Contexts
import { AuthContext } from "../../Context/AuthContext";
// Page Styles
import "../../Style/pagestyle.scss";
import OnlineInvoice from "./OnlineInvoice";
import DirectInvoice from "./DirectInvoice";

export default function Invoice() {
  // Translation context
  const { t } = useContext(AuthContext);

  // Read tab from localStorage or set default
  const handleGetItemTabFromLocalStorage = () =>
    window.localStorage.getItem("invoice_tab");

  const [tab, setTab] = useState(
    handleGetItemTabFromLocalStorage() || "DirectInvoice",
  );

  // Persist tab selection to localStorage
  useEffect(() => {
    window.localStorage.setItem("invoice_tab", tab);
  }, [tab]);

  // Mapping tabs to components
  const TabComponents = {
    DirectInvoice,
    OnlineInvoice,
  };

  const ActiveComponent = TabComponents[tab];

  // Props passed to each tab component
  const tabPropsMap = {
    DirectInvoice,
    OnlineInvoice,
  };

  const activeProps = tabPropsMap[tab] || {};

  // Tab button definitions
  const tabs = [
    { key: "DirectInvoice", label: t("page_direct_invoice") },
    { key: "OnlineInvoice", label: t("page_online_invoice") },
  ];

  return (
    <div className="page-container">
      <Box
        className="tab-container"
        sx={{ position: "relative", marginTop: 8 }}
      >
        <Box sx={{ position: "absolute", bottom: "-2px", width: "100%" }}>
          <Stack
            direction="row"
            alignItems="flex-end"
            justifyContent="space-between"
            sx={{ width: "100%" }}
          >
            <Stack direction="row" className="tab">
              {tabs.map(({ key, label }) => (
                <Button
                  key={key}
                  className={
                    tab === key
                      ? t("class-name-tab-item-active")
                      : t("class-name-tab-item")
                  }
                  onClick={() => setTab(key)}
                >
                  {label}
                </Button>
              ))}
            </Stack>
          </Stack>
        </Box>
      </Box>

      {/* Tab Content with Fade Transition */}
      <Box sx={{ marginTop: "10px" }}>
        <Fade in={true} key={tab} timeout={400}>
          <div>{ActiveComponent && <ActiveComponent {...activeProps} />}</div>
        </Fade>
      </Box>
    </div>
  );
}
